module.exports = __webpack_public_path__ + "static/media/woof.c86ccd0f.mp3";